<template>
  <nav class="build-presets" aria-label="Build presets">
    <span class="build-presets-label">Quick build</span>
    <ul class="build-presets-list">
      <li v-for="preset in items" :key="preset.id">
        <button
          type="button"
          class="build-preset"
          :class="{ 'is-current': preset.id === value }"
          :aria-pressed="String( preset.id === value )"
          @click="$emit('apply', preset)"
        >{{ preset.label }}</button>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  props: {
    value: String,
    items: { type: Array, default: () => [] }
  }
};
</script>

<style scoped>
.build-presets { display: flex; align-items: center; gap: 8px; min-width: 0; height: auto !important; }
.build-presets-label { flex: 0 0 auto; font-size: 11px; letter-spacing: .06em; text-transform: uppercase; color: #616759; }
.build-presets-list { display: flex; gap: 6px; min-width: 0; overflow-x: auto; list-style: none; margin: 0; padding: 3px !important; scrollbar-width: none; }
.build-presets-list::-webkit-scrollbar { display: none; }
.build-presets-list li { flex: 0 0 auto; }
.build-preset { display: inline-flex; align-items: center; min-height: 30px; padding: 4px 12px; border: 1px solid #dedfd7; border-radius: 24px; font: inherit; font-size: 12px; color: #344b35; background: rgba(255, 255, 255, .92); cursor: pointer; white-space: nowrap; }
.build-preset:hover { border-color: #a7b4a0; background: #f3f5ef; }
.build-preset.is-current { color: #fff; background: #344b35; border-color: #344b35; }
.build-preset:focus-visible { outline: 3px solid #718765; outline-offset: 2px; }
@media (max-width: 700px) {
  .build-presets-label { display: none; }
  .build-preset { min-height: 28px; padding: 3px 10px; font-size: 11px; }
}
</style>
